import { Progress } from "@/components/ui/progress";

export default function TrainingTab({ status }) {
  const log = status?.log || "";
  const progress = status?.progress || 0;
  const st = status?.status || "—";

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-3 gap-3">
        <Card label="STATUS" value={st} />
        <Card label="PROGRESS" value={`${progress}%`} accent />
        <Card label="BEST" value={status?.best_model || "—"} />
      </div>
      <Progress value={progress} data-testid="training-tab-progress" />

      <div>
        <div className="label-mono mb-3">// TRAINING LOG</div>
        <div className="border border-border rounded-sm bg-black text-emerald-300 font-mono text-xs p-4 h-[420px] overflow-auto whitespace-pre-wrap" data-testid="training-log">
          {log || <span className="text-muted-foreground">Waiting for pipeline logs…</span>}
        </div>
      </div>
    </div>
  );
}

function Card({ label, value, accent }) {
  return (
    <div className="border border-border p-4 rounded-sm bg-card">
      <div className="label-mono">{label}</div>
      <div className={`num text-xl mt-1 font-display font-semibold uppercase ${accent ? "text-accent" : ""}`}>{value}</div>
    </div>
  );
}
